import { styled, Theme } from '@nexelem/deprecated-theme';

export const HorizontalLine = styled('div')<{
  hasDependencies: boolean;
  isParentExpanded: boolean;
  index: number;
}>(({ theme, hasDependencies, isParentExpanded, index }) => {
  const {
    spacing,
    palette: { getColor },
    client: {
      toDoList: {
        task: { borderAlt },
      },
    },
  } = theme as Theme;

  const borderWidth = hasDependencies ? 3.1 : 11;

  return {
    position: 'absolute',
    display: 'block',
    top: '50%',
    left: '30%',
    transform: 'translate(0, -0.30px)',
    borderBottom: `${spacing(0.25)} ${getColor(borderAlt)} dashed`,
    height: spacing(0.25),
    transition: 'width 200ms ease-out',
    transitionDelay: isParentExpanded ? `${(index + 1) * 150}ms` : '0',
    width: isParentExpanded ? spacing(borderWidth) : 0,
  };
});
